import React from "react";
import { Box, Typography } from "@mui/material";
import DomesticReports from "./DomesticReports";

/**
 * Complaint Reports — uses SR Report data grid (same API as Domestic Reports).
 * Route: /reports/complaints (menuConfig REPORT_COMPLAINT).
 */
const ComplaintReports = () => (
  <Box>
    <Typography variant="h5" sx={{ px: 2, pt: 2, pb: 0, fontWeight: 600 }}>
      Complaint Reports
    </Typography>
    <DomesticReports />
  </Box>
);

export default ComplaintReports;
